/*
销售出库
@y=>fwj
*/
import request from '@/utils/request'

//获取出库状态下拉
export function getckStatusOptions() {
  return request({
    method: "get",
    url: `/yzdservice/api/enum/ck/ty`
  });
}
//获取dialog=>购买证分页列表

export function getdiaGmzList(data, type = '0') {
  return request({
    method: "post",
    url: `/yzdservice/enterprise/dwCk/xsck/selectGmzList/${type}`,
    data: data
  });
}
// 根据购买证id 查询购买证信息

export function getgmzInforMation(type, id,cz) {
  if(cz == 'bg'){ //变更时获取信息
    return request({
      method: "get",
      url: `/yzdservice/enterprise/dwCk/xsck/selectGmzxxById/${type}/${id}/bg`
    });
  }else{
    return request({
      method: "get",
      url: `/yzdservice/enterprise/dwCk/xsck/selectGmzxxById/${type}/${id}`
    });
  }

}
// 根据购买证id 查询运输证列表 (暂时不调)
export function getyszInforMation(data) {
  return request({
    method: "post",
    url: `/yzdservice/enterprise/dwCk/xsck/selectYszList`,
    data: data
  });
}
// （暂时保存）添加接口/yzdservice/enterprise/dwCk/xsck/addOrUpdSave
export function addxsInforMationTemp(data) {
  return request({
    method: "post",
    url: `/yzdservice/enterprise/dwCk/xsck/addOrUpdSaveTemp`,
    data: data
  });
}
// （出库）添加接口/yzdservice/enterprise/dwCk/xsck/addOrUpdSave
export function addxsInforMation(data) {
  return request({
    method: "post",
    url: `/yzdservice/enterprise/dwCk/xsck/addOrUpdSave`,
    data: data
  });
}
//获取仓库下拉且携带库存==>化学品编码
export function getCkListToKc(hxpbm,ckId) {
  if(ckId){ //有仓库主键，则携带
    return request({
      method: "get",
      url: `/yzdservice/enterprise/dwCk/getCkxxAndKcxx/` + hxpbm+`/`+ckId
    });
  }else{
    return request({
      method: "get",
      url: `/yzdservice/enterprise/dwCk/getCkxxAndKcxx/` + hxpbm
    });
  }

}
// 获取经办人列表
///yzdservice/enterprise/dwCk/syck/getLyrList
export function getJbrListToKc() {
  return request({
    method: "get",
    url: `/yzdservice/enterprise/dwCk/syck/getLyrList`
  });
}
// 根据化学品编码获取单位下拉
export function getdwselectionByhxp(hxpbm) {
  return request({
    method: "get",
    url: `/yzdservice/common/hxpDw/` + hxpbm
  });
}
// 获取出库列表
export function getHomeList(data) {
  return request({
    method: "post",
    url: `/yzdservice/enterprise/dwCk/xsck/list`,
    data: data
  });
}
//根据销售出库id查类表
export function getDetailById(id) {
  return request({
    method: "get",
    url: `/yzdservice/enterprise/dwCk/xsck/detail/` + id
  });
}
// 变更保存前/yzdservice/enterprise/dwCk/xsck/changePdkcByXsck
export function saveOfBG(data) {
  return request({
    method: "post",
    url: `/yzdservice/enterprise/dwCk/xsck/changePdkcByXsck`,
    data: data
  });
}
// 删除销售出库'
export function deleteXsckMes(id) {
  return request({
    method: "delete",
    url: "/yzdservice/enterprise/dwCk/xsck/remove/" + id
  });
}

// 最终变更
export function finalBG(data) {
  return request({
    method: "post",
    url: `/yzdservice/enterprise/dwCk/xsck/saveChangeApply`,
    data:data
  });
}
// 导出
export function exportExcel(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/xsck/excelwriter",
    responseType: 'blob',
    data: data
  })
}
